<template>
        <v-dialog
                transition="dialog-bottom-transition"
                v-model="dialog"
                persistent
                max-width="1400"
                scrollable
        >
            <v-card>
                <v-toolbar flat dense color="teal" dark>
                    <v-app-bar-nav-icon>
                        <v-icon left>mdi-sitemap</v-icon>
                    </v-app-bar-nav-icon>
                    <v-toolbar-title>WorkFlow</v-toolbar-title>
                </v-toolbar>
                <v-divider/>
                <v-card-text>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="5">
                                <w-card-form :title="'Opération'">
                                    <template v-slot:body>
                                        <v-simple-table dense>
                                            <template v-slot:default>
                                                <tbody>
                                                <tr>
                                                    <td :style="`background-color: ${tdBackgroundColor};`">
                                                        <strong>{{ $t('module.validation_work_flow') }}</strong>
                                                    </td>
                                                    <td>{{ action.validationWorkFlowName }}</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td :rowspan="action.modules.length + 1"
                                                        :style="`background-color: ${tdBackgroundColor};`">
                                                        <strong>Modules</strong>
                                                    </td>
                                                </tr>
                                                <tr
                                                        v-for="(module, index) in action.modules"
                                                        :key="`module-${index}`"
                                                >
                                                    <td>
                                                        {{ $t(`module.${module.toLowerCase()}`) }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td :style="`background-color: ${tdBackgroundColor};`">
                                                        <strong>Etat</strong>
                                                    </td>
                                                    <td :style="`background-color: ${tdBackgroundColor};`">
                                                        <strong>Validateur</strong>
                                                    </td>
                                                </tr>
                                                <tr
                                                        v-for="(step, index) in action.steps"
                                                        :key="`step-${index}`"
                                                >
                                                    <td>
                                                        <strong class="teal--text"> {{ step.stepName }}</strong>
                                                    </td>
                                                    <td>
                                                        <strong v-if="step.validatorType === 'RESPONSIBLE'" class="red--text">
                                                            Responsable Hiérarchique
                                                        </strong>
                                                        <strong v-if="step.validatorType === 'SPECIFIC'">
                                                            {{ step.validatorFullName }}</strong>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </template>
                                </w-card-form>
                            </v-col>
                            <v-col cols="7">
                                <w-card-form :title="$t('module.workers')">
                                    <template v-slot:body>
                                        <v-col cols="6">
                                            <w-text-field
                                                    v-model="searchWorker"
                                                    label="Rechercher"
                                            ></w-text-field>
                                        </v-col>
                                        <v-data-table
                                                :headers="workerHeaders"
                                                :items="action.workers"
                                                :search="searchWorker"
                                                dense
                                        >
                                            <template v-slot:[`item.code`]="{ item }">
                                                <v-chip
                                                        color="teal"
                                                        label
                                                        dark
                                                        small
                                                        :class="`ma-1`"
                                                >
                                                    <strong>
                                                        {{ item.code }}
                                                    </strong>
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item.name`]="{ item }">
                                                <v-chip
                                                        color="blue"
                                                        label
                                                        dark
                                                        small
                                                        :class="`ma-1`"
                                                >
                                                    <strong>
                                                        {{ item.name }}
                                                    </strong>
                                                </v-chip>
                                            </template>
                                        </v-data-table>
                                    </template>
                                </w-card-form>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                            depressed
                            color="teal"
                            outlined
                            @click="getBack"
                    >
                        {{ $t('common.close') }}
                        <v-icon right>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                            depressed
                            color="orange"
                            dark
                            @click="edit"
                    >
                        {{ $t('common.edit') }}
                        <v-icon right>mdi-pencil-box-multiple</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
import useSharedData from "@/use/SharedData.js";
import useTools from "@/use/Tools.js";
import {onMounted, ref} from "vue";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export default {
    name: "ValidationWorkFlowActionView",
    setup() {
        const {dialog, loading, chipElevation} = useSharedData();
        const {$route, $i18n, $router} = useTools();
        const {getBack} = useSharedMethod();


        const action = ref({
            workers: [],
            modules: [],
            steps: [],
        });

        function findById(id) {
            loading.value = true;
            axios.get(`/validationWorkFlowActions/${id}`).then(response => {
                action.value = response.data;
            }).finally(() => {
                loading.value = false;
            })
        }

        const workerHeaders = [
            {
                text: $i18n.t("common.code"),
                align: "left",
                value: "code",
                sortable: true,
            },
            {
                text: $i18n.t("common.name"),
                align: "left",
                value: "name",
                sortable: true,
            },
        ];
        const searchWorker = ref('');

        const tdBackgroundColor = "#FFF9C4";

        function edit() {
            $router.push({
                name: 'validation_work_flow_actions.set_validation_work_flow.action',
                params: {actionId: action.value.id}
            });
        }

        onMounted(() => {
            findById($route.params.id);
        })

        return {
            dialog,
            loading,
            chipElevation,
            tdBackgroundColor,
            action,
            workerHeaders,
            searchWorker,
            edit,
            getBack,
        }
    }
}
</script>

<style scoped>

</style>